import * as React from "react";
import { styled } from "@mui/system";
import MUICard from "@mui/material/Card";
import { CardProps as CardPropsMUI, CardTypeMap } from "@mui/material/Card";
import { OverridableComponent } from "@mui/material/OverridableComponent";
export interface CardProps extends CardPropsMUI {}

const CardRoot = styled(
  React.forwardRef<HTMLDivElement, CardProps>((props, ref) => (
    <MUICard ref={ref} elevation={3} {...props} />
  )),
  {
    name: "Card",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiPaper-root.MuiCard-root.MuiPaper-root": {
    background: theme.palette?.primary?.surfaceDefault
  },
  ...(theme.name === "fic" && {
    "&.MuiPaper-root.MuiPaper-elevation.MuiPaper-rounded": {
      borderRadius: "8px",
      boxShadow: "none",
      border: "1px solid " + theme.palette.primary.borderDisabled
    }
  })
}));

export const Card = React.forwardRef<HTMLDivElement, CardProps>(function Card(
  props,
  ref
) {
  return <CardRoot {...props} ref={ref} />;
}) as OverridableComponent<CardTypeMap>;
